import { useLocation } from 'react-router';
import { Link } from 'ui/links';

type ProjectBreakdownLinkProps = {
  to: string;
};

export const TEXT = 'View project breakdown';

export const ProjectBreakdownLink = ({ to }: ProjectBreakdownLinkProps) => {
  const { search } = useLocation();

  return (
    <Link
      data-test="project-breakdown-link"
      useReactRouter
      hasOpenNewTabIcon
      href={`${to}${search}`}
    >
      <span>{TEXT}</span>
    </Link>
  );
};
